import { httpClient } from './http-client';

export interface QueueStatus {
  waitingCount: number;
  inProgressCount: number;
  availableDoctors: number;
  averageWaitTime: number;
}

export interface DoctorQueueStatusResponse {
  success: boolean;
  data?: QueueStatus;
}

export interface AcceptInvitationResponse {
  success: boolean;
  action?: string;
  sessionId?: string;
  message?: string;
}

export interface RejectInvitationResponse {
  success: boolean;
  action?: string;
  message?: string;
}

export const doctorQueueApi = {
  getStatus: async (): Promise<{ status: string; isExpressEnabled: boolean }> => {
    try {
      console.log('[doctorQueueApi] getStatus - fetching doctor status');
      const res = await httpClient.get<{ status: string; isExpressEnabled: boolean }>('/doctors/me/status');
      console.log('[doctorQueueApi] getStatus success:', res);
      return res;
    } catch (err) {
      console.warn('[doctorQueueApi] getStatus error, returning OFFLINE fallback:', err);
      return { status: 'OFFLINE', isExpressEnabled: false };
    }
  },

  getQueueStatus: async (): Promise<QueueStatus> => {
    try {
      console.log('[doctorQueueApi] getQueueStatus - fetching queue metrics');
      const res = await httpClient.get<QueueStatus>('/express/queue/status');
      console.log('[doctorQueueApi] getQueueStatus success:', res);
      return res;
    } catch (err) {
      console.warn('[doctorQueueApi] getQueueStatus error, returning empty metrics:', err);
      return { waitingCount: 0, inProgressCount: 0, availableDoctors: 0, averageWaitTime: 0 };
    }
  },

  updateStatus: async (data: { status: string }): Promise<{ success: boolean; status?: string }> => {
    console.log('[doctorQueueApi] updateStatus - sending status:', data);
    const res = await httpClient.patch<{ success: boolean; status?: string }>('/doctors/me/status', data);
    console.log('[doctorQueueApi] updateStatus response:', res);
    return res;
  },

  acceptInvitation: (expressId: string): Promise<AcceptInvitationResponse> => {
    console.log('[doctorQueueApi] acceptInvitation - expressId:', expressId);
    return httpClient.post<AcceptInvitationResponse>(`/doctors/me/queue/${expressId}/accept`, {});
  },

  rejectInvitation: (expressId: string, reason?: string): Promise<RejectInvitationResponse> => {
    console.log('[doctorQueueApi] rejectInvitation - expressId:', expressId, 'reason:', reason);
    return httpClient.post<RejectInvitationResponse>(`/doctors/me/queue/${expressId}/reject`, { reason });
  },

  getPendingInvitations: async (): Promise<any | null> => {
    try {
      const res = await httpClient.get<any>('/express/doctor/pending-invitations');
      return res?.data || (res && res.invitationId ? res : null);
    } catch {
      return null;
    }
  },
};
